import arrayEach from 'fast-loops/lib/arrayEach';

import deprecate from './deprecate';

deprecate('The LVHA plugin (fela-plugin-lvha) is deprecated, please remove it from your Fela configuration.\nIt is obsolete as sorting is now handled by the renderer itself. See https://github.com/rofrischmann/fela/pull/573');

var precedence = {
  ':link': 0,
  ':visited': 1,
  ':hover': 2,
  ':focus': 3,
  ':active': 4
};

var pseudoClasses = Object.keys(precedence);

function orderLVHA(style) {
  var pseudoList = [];

  for (var property in style) {
    if (precedence.hasOwnProperty(property)) {
      pseudoList[precedence[property]] = style[property];
      delete style[property];
    }
  }

  arrayEach(pseudoList, function (pseudoStyle, index) {
    if (pseudoStyle) {
      style[pseudoClasses[index]] = pseudoStyle;
    }
  });

  return style;
}

export default (function () {
  return orderLVHA;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-plugin-lvha/es/index.js
// module id = 910
// module chunks = 0